module.exports = __webpack_public_path__ + "static/media/po-reman-6.49735128.png";